import { v4 as uuid } from 'uuid';

export class UuidGenerator {
  static create(): string {
    return uuid();
  }
}
